import styled from 'styled-components';
import { Radio } from 'antd';


export const ItemContainer = styled.div<{marinBtm?:number}>`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	flex-shrink: 0;
	margin-bottom:${(props)=> props.marinBtm ? `${props.marinBtm}px`: '0'};

	min-height: 0;	

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		
	}
`;

export const FontTitleContainer = styled(ItemContainer)`
	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		padding-bottom: unset;
	}
`;

export const Title = styled.div`
	font-size: 12px;
	font-weight: 600;
	margin-bottom: 7px;

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    	
	}
`;

export const Symbols = styled.div`
	display: flex;
	align-items:center
`;

export const SymbolBtn = styled.div<{isLastItem?:boolean}>`
	cursor: pointer;	
	border: ${(props) => `2px solid ${props.theme.colors.borderColor}`};
	background-color:${(props) => props.theme.colors.white};	
	margin-right:${(props)=> props.isLastItem ? '0': '10px'};
	& .svg-wrapper{
		width:50px;
		height:30px;
		display:flex;
		align-items: center;
		justify-content: center;
	}
`;

export const FontWrapper = styled.div`
	display: inline-grid;
	grid-template-columns: calc(100%/5 - 40px/5) calc(100%/5 - 40px/5) calc(100%/5 - 40px/5) calc(100%/5 - 40px/5) calc(100%/5 - 40px/5);
	width: 100%;
	column-gap: 10px;
`;

export const FontContent = styled.div`
	width:100%;
	display:flex;
	align-items: center;
	justify-content: center;
	height:30px;
	cursor: pointer;	
	border: ${(props) => `2px solid ${props.theme.colors.borderColor}`};
	background-color:${(props) => props.theme.colors.white};	
`;

export const StyledRadioGroup = styled(Radio.Group)`
	.ant-radio:hover {
		border-color: ${({theme}) => theme.colors.fallow}; 
	}
	
	.ant-radio-checked .ant-radio-inner {
		border-color: ${({theme}) => theme.colors.fallow}; 
		
		:after {
			background-color: ${({theme}) => theme.colors.fallow}; 
		}
	}
	
	.ant-radio-wrapper {
		font-size: 15px;
		width: 100%;
		
		display: flex;
		flex-direction: row-reverse;
		justify-content: space-between;
		align-items: center;
		
		margin-bottom: 30px;
		
		span:last-child {
		  padding-left: unset;
		}

		& > span:last-child {
			width: 100%;
		}

		@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
			margin-bottom: 10px;
		}		
	}
`;


